import { FeatureFlag } from 'core/enums/feature-flag';
import { Feature } from 'core/enums/features';

export const FeaturePermission: Partial<Record<Feature, FeatureFlag[]>> = {
  [Feature.Account]: [FeatureFlag.AccountRoute],
  [Feature.ViewBalance]: [
    FeatureFlag.ViewBalanceRoute,
    FeatureFlag.ViewBalanceDownloadLatestStatementCard,
    FeatureFlag.ViewBalancePriceAdjustmentCard,
    FeatureFlag.ViewBalancePaymentType,
    FeatureFlag.ViewBalanceLastTransactionCard,
    FeatureFlag.ViewBalanceShowPaymentNotice,
    FeatureFlag.ViewBalanceQuickLinks,
    FeatureFlag.ViewBalancePendingQuotes,
    FeatureFlag.ViewBalanceCurrencyConversion,
    FeatureFlag.ViewBalanceAccountDetails,
  ],
  [Feature.BillingExplained]: [FeatureFlag.BillingExplainedRoute],
  [Feature.TransactionHistory]: [
    FeatureFlag.TransactionHistoryRoute,
    FeatureFlag.TransactionHistoryCalenderSelection,
    FeatureFlag.TransactionHistoryFilterBar,
    FeatureFlag.TransactionHistoryTableHeaderCard,
  ],
  [Feature.MonthlyStatements]: [FeatureFlag.MonthlyStatementsRoute],
  [Feature.PaymentMethods]: [FeatureFlag.UpdatePaymentMethodsRoute],
  [Feature.AmountToPay]: [FeatureFlag.AmountToPayRoute],
  [Feature.Dashboard]: [
    FeatureFlag.DashboardRoute,
    FeatureFlag.DashboardAnnouncementBanner,
    FeatureFlag.DashboardFilterBar,
    FeatureFlag.DashboardTabViews,
    FeatureFlag.DashboardQuickLinks,
    FeatureFlag.DashboardPendingQuotes,
    FeatureFlag.DashboardContractExpirationBanner,
  ],
  [Feature.DashboardViewing]: [FeatureFlag.DashboardViewingRoute],
  [Feature.DashboardInternet]: [FeatureFlag.DashboardInternetRoute],
  [Feature.DashboardInsurance]: [FeatureFlag.DashboardInsuranceRoute],
  [Feature.DashboardInactive]: [FeatureFlag.DashboardInactiveRoute],
  [Feature.DashboardSafety]: [FeatureFlag.DashboardSafetyRoute],
  [Feature.Subscriptions]: [
    FeatureFlag.SubscriptionsRoute,
    FeatureFlag.SubscriptionFilterBar,
    FeatureFlag.SubscriptionTabViews,
  ],
  [Feature.SelectManage]: [FeatureFlag.SelectManageRoute],
  [Feature.SelectViewing]: [FeatureFlag.SelectViewingRoute],
  [Feature.SubscriptionViewing]: [FeatureFlag.SubscriptionViewingRoute],
  [Feature.SubscriptionInactive]: [FeatureFlag.SubscriptionInactiveRoute],
  [Feature.SubscriptionPending]: [FeatureFlag.SubscriptionPendingRoute],
  [Feature.SubscriptionLinkPackageSA]: [FeatureFlag.SubscriptionLinkPackageSA],
  [Feature.LinkPackageQuoteBreakdown]: [FeatureFlag.LinkPackageQuoteBreakdown],
  [Feature.FixError]: [FeatureFlag.FixErrorRoute, FeatureFlag.FixErrorForm],
  [Feature.Safety]: [FeatureFlag.SafetyRoute],
  [Feature.Offers]: [FeatureFlag.OffersRoute],
  [Feature.Activate]: [FeatureFlag.ActivateRoute],
  [Feature.AllProducts]: [FeatureFlag.AllProductsRoute],
  [Feature.HolidayHome]: [FeatureFlag.HolidayHomeRoute],
  [Feature.Rewards]: [FeatureFlag.RewardsRoute],
  [Feature.Premium]: [FeatureFlag.PremiumRoute],
  [Feature.WhatIsRewards]: [FeatureFlag.WhatIsRewardsRoute],
  [Feature.AvailableRewards]: [FeatureFlag.AvailableRewardsRoute],
  [Feature.EarnMoreStars]: [FeatureFlag.EarnMoreStarsRoute],
  [Feature.Competitions]: [FeatureFlag.CompetitionsRoute],
  [Feature.RewardsHistory]: [FeatureFlag.RewardsHistoryRoute],
  [Feature.Profile]: [
    FeatureFlag.ProfileRoute,
    FeatureFlag.ProfileRewardsCard,
    FeatureFlag.ProfilePreferences,
    FeatureFlag.ProfilePostalAddress,
    FeatureFlag.ProfilePicture,
    FeatureFlag.ProfileDataRequest,
    FeatureFlag.ProfileOptionalEmail,
  ],
  [Feature.ProfilePreferences]: [FeatureFlag.ProfilePreferencesRoute],
  [Feature.Utils]: [
    FeatureFlag.DevTools,
    FeatureFlag.ScheduledMaintenancePanel,
    FeatureFlag.UnexpectedMaintenancePanel,
  ],
  [Feature.Menu]: [FeatureFlag.MenuProfileCard, FeatureFlag.MenuAmountToPayCard],
  [Feature.Action]: [
    FeatureFlag.ActionRoute,
    FeatureFlag.ProductDisconnection,
    FeatureFlag.BypassReconnections,
    FeatureFlag.ActionFeatureActivate,
    FeatureFlag.ActionFeatureActivateEPL,
    FeatureFlag.ActionFeatureLinkPackage,
    FeatureFlag.ActionFeatureChangePackage,
    FeatureFlag.ActionFeatureDashboardChangePackage,
    FeatureFlag.ActionFeatureReconnectPackage,
    // FeatureFlag.ActionFeatureDirectReconnectPackage,
    FeatureFlag.ActionFeatureDisconnectPackage,
    FeatureFlag.ActionFeatureCancelShowmax,
    FeatureFlag.ActionFeatureCancelBritbox,
    FeatureFlag.ActionFeatureMonthlyToBundle,
    FeatureFlag.ActionFeatureStreamMonthlyToBundle,
    FeatureFlag.ActionFeatureStreamRenewBundle,
    FeatureFlag.ActionFeatureRecontractBundle,
    FeatureFlag.ActionFeatureRedeemVoucher,
    FeatureFlag.ActionFeatureSwitchToStream,
    FeatureFlag.ActionFeatureGetQuote,
    FeatureFlag.ActionFeatureCaptureBundle,
    FeatureFlag.ActionFeatureCreateXtraview,
    FeatureFlag.ActionFeatureBreakXtraview,
    FeatureFlag.ActionFeatureInsureDecoder,
    FeatureFlag.ActionFeatureCancelInsurance,
    FeatureFlag.ActionFeatureViewInsurancePolicy,
    FeatureFlag.ActionFeatureManageBeneficiaries,
    FeatureFlag.ActionFeatureAddBeneficiary,
    FeatureFlag.ActionFeatureManageMembers,
    FeatureFlag.ActionFeatureViewLinkProduct,
    FeatureFlag.ActionFeatureClearErrorCode,
    FeatureFlag.ActionFeatureViewLinked,
    FeatureFlag.ActionFeatureProductHighlights,
    FeatureFlag.ActionFeatureOtherAddOns,
    FeatureFlag.ActionFeatureExtraStream,
    FeatureFlag.ActionFeatureCancelDecoderInsurance,
    FeatureFlag.ActionFeatureSubmitClaim,
    FeatureFlag.ActionFeatureWhatsCovered,
    FeatureFlag.ActionFeaturePolicyDocuments,
    FeatureFlag.ActionFeatureFuneralPolicyDocuments,
    FeatureFlag.ActionFeatureSubscriptionPolicyDocuments,
    FeatureFlag.ActionFeatureDecoderPolicyDocuments,
    FeatureFlag.ActionFeatureDebtWaiverPolicyDocuments,
    FeatureFlag.ActionFeatureCodeOfConduct,
    FeatureFlag.ActionFeatureComplaintsPolicy,
    FeatureFlag.ActionFeatureSpeakToAnAgent,
    FeatureFlag.ActionFeatureRelocateFibre,
    FeatureFlag.ActionFeatureCancelFibreService,
    FeatureFlag.UseGhostAcceptQuote,
    FeatureFlag.UseChangePackageGhostAcceptQuote,
    FeatureFlag.HasShowmax,
    FeatureFlag.HasShowmaxPL,
    FeatureFlag.HasBritbox,
    FeatureFlag.HasNetflix,
    FeatureFlag.HasDisney,
    FeatureFlag.HasMobileStream,
    FeatureFlag.SubscriptionActivationLink,
    FeatureFlag.CancelPackageChangeSchedule,
    FeatureFlag.DashboardActivationLink,
    FeatureFlag.ActionFeatureTopUP,
    FeatureFlag.ActionFeatureSetInternetSpeedLimit,
    FeatureFlag.ActionFeatureDataTransfer,
    FeatureFlag.ActionFeatureUpdateDeviceName,
    FeatureFlag.ActionFeatureLocationUpdate,
    FeatureFlag.ActionFeatureBalanceEnquiry,
    FeatureFlag.ActionFeatureGetSimStatus,
    FeatureFlag.ActionFeatureChangeInternetPackage,
    FeatureFlag.ActionFeatureInternetDisconnect,
    FeatureFlag.ActionFeatureInternetReconnect,
    FeatureFlag.ActionFeatureWatchNow,
    FeatureFlag.LinkPackageEmailStep,
  ],
  [Feature.Internet]: [FeatureFlag.InternetRoute],
  [Feature.Insurance]: [
    FeatureFlag.InsuranceRoute,
    FeatureFlag.InsurancePolicyUpdateAnnouncementBanner,
    FeatureFlag.InsuranceFuneralCoverFamilyPlans,
    FeatureFlag.InsuranceFuneralCoverPersonal,
  ],
  [Feature.RewardsPremiumStatus]: [FeatureFlag.RewardsPremiumStatusRoute],
  [Feature.RewardsWhatIsPremium]: [FeatureFlag.RewardsWhatIsPremiumRoute],
  [Feature.BoxOffice]: [FeatureFlag.BoxOfficeRoute],
  [Feature.Inbox]: [FeatureFlag.InboxRoute],
  [Feature.RecurringPayment]: [FeatureFlag.RecurringPaymentRoute],
};